function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { useEffect } from "react";
/**
 * Proper state management for nested modals.
 * Simplified, but inspired by material-ui's ModalManager class.
 */

var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);

    _defineProperty(this, "modals", void 0);

    this.modals = [];
  }

  _createClass(ModalManager, [{
    key: "add",
    value: function add(modal) {
      this.modals.push(modal);
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      this.modals = this.modals.filter(function (_modal) {
        return _modal !== modal;
      });
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      var topmostModal = this.modals[this.modals.length - 1];
      return topmostModal === modal;
    }
  }]);

  return ModalManager;
}();

export var manager = new ModalManager();
export function useModalManager(ref, isOpen) {
  useEffect(function () {
    if (isOpen) {
      manager.add(ref);
    }

    return function () {
      manager.remove(ref);
    };
  }, [isOpen, ref]);
}